import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { PublishMap, PublishStatus } from "service/group";
import { isTrue } from "service/service";

export default function ListStatus({
    state,
    hasTask
}: {
    state: PublishStatus;
    hasTask: BooleanValue;
}) {
    const classMap: { [key: string]: string } = {
        "0": style.state,
        "1": style.state,
        "2": style.doing
    };

    return (
        <div
            className={classNames(style.root, {
                [classMap[state]]: isTrue(hasTask),
                [style.empty]: !isTrue(hasTask)
            })}>
            {isTrue(hasTask) ? PublishMap[state] : "未添加任务"}
        </div>
    );
}
